'use strict';
module.exports = require('./Sidebar.vue');